<button
  class="btn btn-sm sds-legal-btn"
  type="button"
  (click)="open()"
  [pTooltip]="definition.tooltipKey | translate"
  tooltipPosition="bottom"
  [attr.aria-label]="definition.tooltipKey | translate"
>
  <span class="sds-legal-glyph" aria-hidden="true">§</span>
</button>

<p-dialog
  [(visible)]="dialogVisible"
  [style]="{ width: '86vw', height: '88vh', maxWidth: '1180px' }"
  [modal]="true"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="11000"
  (onHide)="close()"
  styleClass="sds-legal-dialog"
>
  <ng-template pTemplate="header">
    <div class="sds-legal-header">
      <span class="sds-legal-header-glyph" aria-hidden="true">§</span>
      <span class="sds-legal-header-text">
        <span class="sds-legal-header-title">{{ definition.titleKey | translate }}</span>
        <small class="sds-legal-header-sub">{{ definition.subtitleKey | translate }}</small>
      </span>
    </div>
  </ng-template>

  <div class="sds-legal-toolbar">
    <div class="sds-legal-source">
      <i class="pi pi-info-circle"></i>
      <span [translate]="'SDS_LEGAL_SOURCE'"></span>
    </div>

    <div class="sds-legal-tools">
      <div class="sds-legal-zoom" role="group" [attr.aria-label]="'SDS_LEGAL_ZOOM' | translate">
        <button
          class="btn btn-icon sds-legal-zoom-btn"
          type="button"
          (click)="changeZoom(-1)"
          [disabled]="!canZoomOut"
          [pTooltip]="'SDS_LEGAL_ZOOM_OUT' | translate"
          tooltipPosition="bottom"
        >
          <i class="pi pi-minus"></i>
        </button>
        <button
          class="btn sds-legal-zoom-level"
          type="button"
          (click)="resetZoom()"
          [pTooltip]="'SDS_LEGAL_ZOOM_RESET' | translate"
          tooltipPosition="bottom"
        >
          {{ zoomLabel }}
        </button>
        <button
          class="btn btn-icon sds-legal-zoom-btn"
          type="button"
          (click)="changeZoom(1)"
          [disabled]="!canZoomIn"
          [pTooltip]="'SDS_LEGAL_ZOOM_IN' | translate"
          tooltipPosition="bottom"
        >
          <i class="pi pi-plus"></i>
        </button>
      </div>

      <button
        class="btn btn-outline-primary btn-sm sds-legal-external"
        type="button"
        (click)="openExternally()"
        [pTooltip]="'SDS_LEGAL_OPEN_EXTERNAL_HINT' | translate"
        tooltipPosition="bottom"
      >
        <i class="pi pi-external-link"></i>
        <span [translate]="'SDS_LEGAL_OPEN_EXTERNAL'"></span>
      </button>
    </div>
  </div>

  <div class="sds-legal-body">
    <div class="sds-legal-state" *ngIf="loading">
      <i class="pi pi-spin pi-spinner"></i>
      <span [translate]="'SDS_LEGAL_LOADING'"></span>
    </div>

    <div class="sds-legal-state sds-legal-state-error" *ngIf="blocked">
      <i class="pi pi-exclamation-triangle"></i>
      <span [translate]="'SDS_LEGAL_UNAVAILABLE'"></span>
      <button class="btn btn-primary btn-sm" type="button" (click)="openExternally()">
        <i class="pi pi-external-link"></i>
        <span [translate]="'SDS_LEGAL_OPEN_EXTERNAL'"></span>
      </button>
    </div>

    <div class="sds-legal-frame-wrap" *ngIf="frameUrl && !blocked">
      <iframe
        [src]="frameUrl"
        [style.width]="frameSize"
        [style.height]="frameSize"
        [style.transform]="frameTransform"
        class="sds-legal-frame"
        [class.sds-legal-frame-hidden]="loading"
        (load)="onFrameLoaded()"
        [title]="definition.titleKey | translate"
        referrerpolicy="no-referrer"
        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        frameborder="0"
      ></iframe>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn btn-outline-secondary" type="button" (click)="close()">
      <span [translate]="'CLOSE'"></span>
    </button>
  </ng-template>
</p-dialog>
